<template>
  <div class="container">
    <h4 class="title is-4">Preferences</h4>
    <div class="field has-addons">
      <div class="control is-expanded">
        <input class="input" v-model="newPreferenceName" @keyup.enter="submitNewPreference()" />
      </div>
      <div class="control">
        <button class="button" @click="submitNewPreference()" @keyup.enter="submitNewPreference()">
          Add New Preference
        </button>
      </div>
    </div>
    <table class="table">
      <thead>
        <th>Tag Id</th>
        <th>Name</th>
        <th></th>
      </thead>
      <tbody v-for="preference in preferences" :key="preference.id">
        <td>{{ preference.id }}</td>
        <td>
          <router-link
            :to="{ name: 'StaffRenamePreferences', params: { preferenceId: preference.id } }"
          >
            {{ preference.name }}
          </router-link>
        </td>
        <td>
          <router-link
            :to="{ name: 'StaffRenamePreferences', params: { preferenceId: preference.id } }"
          >
            <i class="fa fa-edit"></i>
          </router-link>
        </td>
      </tbody>
    </table>
  </div>
</template>

<script>
import User from '@/services/users/'
import Preference from '@/services/preferences/'

export default {
  data() {
    return {
      newPreferenceName: '',
      preferences: [],
    }
  },
  created() {
    this.refreshData()
  },
  methods: {
    submitNewPreference() {
      let newPreference = Preference.create()
      newPreference.name = this.newPreferenceName
      Preference.api.create(newPreference).then(() => {
        this.refreshData()
      })
    },
    refreshData() {
      Preference.api.list().then(data => {
        this.preferences = data.results
      })
    },
  },
}
</script>

<style scoped></style>
